import React, { memo } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
;
import { Button, Card, CardContent, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;;
import dayjs from 'dayjs-ext';
import { DATE_DAY_SMONTH_YEAR } from 'src/ui/const';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LogItemAction = ({ icon, onClick, title, className }) => (
  <Button isColor="text" className="is-rounded" onClick={onClick} title={title}>
    <span className={classNames('icon', 'is-medium', className)}>
      <FontAwesomeIcon icon={icon} size="lg" />
    </span>
  </Button>
);

const LogItem = memo(
  ({
    backgroundAssessmentLog,
    item,
    unsaved,
    // onEdit,
    onDelete,
  }) => {
    const TYPES = {
      [backgroundAssessmentLog.acknowledgedBackgroundAssessmentLogType]:
        'Acknowledged',
      [backgroundAssessmentLog.resolvedBackgroundAssessmentLogType]: 'Resolved',
      [backgroundAssessmentLog.userCommentBackgroundAssessmentLogType]:
        'User Comment',
    };

    return (
      <Card key={item.id} className={classNames('log-item', { unsaved })}>
        <CardContent>
          <Columns>
            <Column className="log-contents">
              <div className="log-header">
                <div className="type">
                  {TYPES[item.backgroundAssessmentLogType.id]}
                </div>
                <div className="date">
                  {dayjs(item.date)
                    .utc()
                    .format(DATE_DAY_SMONTH_YEAR)}
                </div>
                <div className="originator">From: {item.originator}</div>
              </div>
              <div
                className="comment"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: item.details }}
              />
            </Column>
            {unsaved && (
              <Column isSize="narrow" className="log-actions">
                {/*
              <LogItemAction
                title='Edit'
                icon={['fal', 'edit']}
                onClick={onEdit}
                className='has-text-info'
              />
              */}
                <LogItemAction
                  title="Delete"
                  icon={['fal', 'trash-alt']}
                  onClick={onDelete}
                  className="has-text-danger"
                />
              </Column>
            )}
          </Columns>
        </CardContent>
      </Card>
    );
  }
);

const ComplianceDetailLog = ({
  unsavedLogs,
  backgroundAssessmentLog,
  // onEditUnsavedLog,
  onDeleteUnsavedLog,
}) => (
  <div className="compliance-detail-log">
    {unsavedLogs.length > 0 && (
      <Columns>
        <Column>
          <MuiTitle isSize="4" hasTextColor="info" tag="h3">
            Unsaved Logs
          </MuiTitle>
          {unsavedLogs.map((item, i) => (
            <LogItem
              unsaved
              key={i}
              item={item}
              backgroundAssessmentLog={backgroundAssessmentLog}
              // onEdit={() => onEditUnsavedLog(i, newItem)}
              onDelete={() => onDeleteUnsavedLog(i)}
            />
          ))}
        </Column>
      </Columns>
    )}
    <Columns>
      <Column>
        <MuiTitle isSize="4" hasTextColor="info" tag="h3">
          Saved Logs
        </MuiTitle>
        {backgroundAssessmentLog.backgroundAssessmentLogs.map(item => (
          <LogItem
            key={item.id}
            item={item}
            backgroundAssessmentLog={backgroundAssessmentLog}
          />
        ))}
      </Column>
    </Columns>
  </div>
);

LogItemAction.propTypes = {
  icon: propTypes.arrayOf(propTypes.string).isRequired,
  onClick: propTypes.func.isRequired,
  title: propTypes.string.isRequired,
  className: propTypes.string,
};

LogItemAction.defaultProps = {
  className: '',
};

LogItem.propTypes = {
  item: propTypes.object.isRequired,
  unsaved: propTypes.bool,
  backgroundAssessmentLog: propTypes.object.isRequired,
  // onEdit: propTypes.func,
  onDelete: propTypes.func,
};

LogItem.defaultProps = {
  unsaved: false,
  // onEdit: () => {},
  onDelete: () => {},
};

ComplianceDetailLog.propTypes = {
  backgroundAssessmentLog: propTypes.object.isRequired,
  unsavedLogs: propTypes.array.isRequired,
  // onEditUnsavedLog: propTypes.func.isRequired,
  onDeleteUnsavedLog: propTypes.func.isRequired,
};

const memoizedComplianceDetailLog = memo(ComplianceDetailLog);
export { memoizedComplianceDetailLog as ComplianceDetailLog };
